import "./styles/_grid-system.scss";
import "./styles/_grid.scss";
import "./styles/_responsive.scss";
import "./styles/_icomoon.scss";
import "./styles/_typography.scss";
import "./styles/_accessibility.scss";
import "./styles/_animations.scss";
import "./styles/_assets.scss";
import "./styles/_reset.scss";
import "@coddicat/vue-pinch-scroll-zoom/style.css";
import VueStatic from "vue-static";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { createGtm } from "@gtm-support/vue-gtm";
import App from "./App.vue";
import router from "./router";

// ① leggi il consenso salvato
const consent = localStorage.getItem('cookie_consent');   // 'granted' | 'denied' | null
const enabled = consent === 'granted';

const app = createApp(App);
app.use(createPinia());
app.use(VueStatic);
app.use(router);

app.use(createGtm({
  id: 'GTM-T3JHX3LF',
  vueRouter:     router,   // page_view automatici alle route
  enabled:     enabled,  // se il consenso è 'granted'
  debug:          true,   // true se vuoi log in devtools
  loadScript:     true,    // mettilo a false se tieni lo snippet html
  defer:          false,    // se vuoi <script defer>
  trackViewEventName: 'page_view',
}));


app.mount("#app");